import { render, staticRenderFns } from "./SingleOrderHeaderAndSubmitActions.vue?vue&type=template&id=220e2990&"
import script from "./SingleOrderHeaderAndSubmitActions.vue?vue&type=script&lang=ts&"
export * from "./SingleOrderHeaderAndSubmitActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
